<template>
  <ChartFrame :title="$t('Chart__Titles__name')">
    <Switcher :options="chartTypes" v-model="currentChartType" />
    <RadioButtons :options="years" v-model="currentYear" />
    <ApexChart
      v-show="currentChartType === chartTypes[1]"
      :height="600"
      :options="optionsTreemap"
      :series="currentTreemapSeries"
    />
    <ApexChart
      v-show="currentChartType === chartTypes[0]"
      ref="barChart"
      :height="800"
      :options="optionsBar"
      :series="currentBarSeries"
    />
  </ChartFrame>
</template>

<script>
import ChartFrame from '@/components/ChartPartials/ChartFrame';
import RadioButtons from '@/components/Ui/RadioButtons';
import Switcher from '@/components/Ui/Switcher';
import dataTreemap from '@/assets/json/TitlesTreemap.json';
import dataBar from '@/assets/json/TitlesBar.json';
import { sortAxisBasedOnDataValues } from '@/utils';
import { apexChartsDefaults } from '@/components/ChartPartials/setApexChartsDefaults';

export default {
  name: 'Titles',
  components: {
    ChartFrame,
    RadioButtons,
    Switcher
  },
  data() {
    return {
      chartTypes: [
        this.$t('ChartType__BarChart__name'),
        this.$t('ChartType__Treemap__name')
      ],
      sheetsTreemap: dataTreemap,
      sheetsBar: dataBar,
      years: dataTreemap[0].series.map(s => s.name),
      currentYearData: null,
      currentChartTypeData: null,
      xAxisOriginal: dataBar[0].axis,
      optionsTreemap: {
        chart: {
          type: 'treemap'
        },
        dataLabels: {
          enabled: true,
          formatter(val, opts) {
            return opts.value > 5 ? val : '';
          }
        },
        legend: {
          show: false
        }
      },
      optionsBar: {
        chart: {
          type: 'bar'
        },
        dataLabels: {
          background: {
            enabled: true,
            foreColor: apexChartsDefaults.colors[0],
            opacity: 0.9
          }
        },
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        xaxis: {
          categories: []
        },
        legend: {
          show: false
        }
      }
    };
  },
  computed: {
    currentYear: {
      get() {
        return this.currentYearData
          ? this.currentYearData
          : this.years[this.years.length - 1];
      },
      set(val) {
        this.currentYearData = val;
      }
    },
    currentChartType: {
      get() {
        return this.currentChartTypeData
          ? this.currentChartTypeData
          : this.chartTypes[0];
      },
      set(val) {
        this.currentChartTypeData = val;
      }
    },
    currentTreemapSeries() {
      const currentTreemapSeries = this.sheetsTreemap[0].series[
        this.years.indexOf(this.currentYear)
      ];
      return [
        {
          name: currentTreemapSeries.name,
          data: currentTreemapSeries.data.map(item => ({
            x: this.$t(item.x),
            y: item.y
          }))
        }
      ];
    },
    currentBarSeries() {
      const currentSeries = this.sheetsBar[0].series[
        this.years.indexOf(this.currentYear)
      ];
      return [
        {
          name: currentSeries.name,
          data: currentSeries.data.slice(0).sort((a, b) => b - a)
        }
      ];
    }
  },
  watch: {
    currentBarSeries: {
      immediate: true,
      deep: true,
      /**
       * Re-ordering xAxis in a descending order, based on the
       * data values in the currentBarSeries
       * @param currentBarSeries
       */
      handler(currentBarSeries) {
        const currentSeries = this.sheetsBar[0].series[
          this.years.indexOf(this.currentYear)
        ];
        let newXAxis = sortAxisBasedOnDataValues(
          currentSeries,
          this.xAxisOriginal,
          currentBarSeries
        );
        // translate categories
        newXAxis = newXAxis.map(cat => this.$t(cat));
        this.$set(this.optionsBar.xaxis, 'categories', newXAxis);
        if (this.$refs.barChart && this.$refs.barChart.chart) {
          this.$refs.barChart.chart.updateOptions(this.optionsBar);
        }
      }
    }
  }
};
</script>
